import SectionReveal from "@/components/SectionReveal";

export default function EditorialSection({
  number,
  label,
  title,
  body,
  children,
  dark = false,
  className = "",
  id,
}) {
  return (
    <section id={id} className={`lf-editorial-section ${dark ? "lf-editorial-dark" : ""} ${className}`}>
      <div className="lf-container">
        <SectionReveal as="header" className="lf-editorial-intro">
          <div className="lf-section-index" aria-hidden="true">{number}</div>
          <div>
            <p className="lf-eyebrow">{label}</p>
            <h2 className="lf-editorial-title">{title}</h2>
            {body ? <p className="lf-editorial-copy">{body}</p> : null}
          </div>
        </SectionReveal>
        {children}
      </div>
    </section>
  );
}
